exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".id[data-v-6babe129] {\n  font-size: .8em;\n  padding-left: 5px;\n  color: #b2b2b2;\n}\n", ""]);

// exports
